import React, {useEffect} from 'react'
import {isBefore, format} from 'date-fns'
import {makeStyles} from '@material-ui/core/styles'
import {Box, CssBaseline} from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import {connect} from 'react-redux'
import {dataActions} from '../../../actions'
import AuditAllRolesTable from './AuditAllDeptRoles/AuditAllDeptRolesTable'

// using hook API
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        height: '93vh',
        marginTop: '3.3rem',
        overflowY: 'auto',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '-webkit-fill-available',
    },
}))

const AuditAllDeptRoles = props => {
    const classes = useStyles()
    const {token, userName, allusers, getallusers, fetchingAllusers} = props

    useEffect(() => {
        getallusers(token)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const todayDate = new Date()
    const twoYearsAgo = todayDate.setYear(todayDate.getFullYear() - 2)

    const enhancedallusers = allusers
        ? allusers.map(item => {
              return {
                  ...item,
                  approle: item.role
                      ? item.isSuper
                          ? 'superadmin'
                          : item.role
                      : item.isSuper
                      ? 'superadmin'
                      : 'none',
                  lastLoginDate: item.lastLogin
                      ? format(new Date(item.lastLogin), 'MM/dd/yyyy')
                      : 'Not Found',
                  loggedin2Years: isBefore(
                      new Date(item.lastLogin),
                      twoYearsAgo
                  )
                      ? false
                      : true,
              }
          })
        : []

    return (
        <>
            <CssBaseline />
            <div className={classes.root}>
                {fetchingAllusers ? (
                    <Box
                        className={classes.container}
                        style={{alignItems: 'center', justifyContent: 'center'}}
                    >
                        <CircularProgress
                            style={{
                                color: '#00853e',
                            }}
                            thickness={3}
                        />
                    </Box>
                ) : (
                    <>
                        <Box className={classes.container}>
                            <AuditAllRolesTable
                                allusers={[...enhancedallusers]}
                                userName={userName}
                            />
                        </Box>
                    </>
                )}
            </div>
        </>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        allusers: state.superadminsdata.allusers,
        fetchingAllusers: state.superadminsdata.fetchingAllusers,
        userName: state.authentication.displayname,
    }
}

const mapDispatchToProps = {
    getallusers: token => dataActions.allusersGetRequest(token),
}

export default connect(mapStateToProps, mapDispatchToProps)(AuditAllDeptRoles)
